import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "condensed", "flush", "hover", "maxHeight", "ScrollContainer"];
import styled from 'foundations-theming/utils';
import { Table } from './Table';
import devLogger from 'react-utils/devLogger';
import { ScrollContainer as ScrollContainerComponent } from '../ScrollContainer';
import { filterProps } from '../../../utils/filterProps';
import { useMapTokenPropsToCSS } from '../../../hooks/useMapTokenPropsToCSS';
import { isIE11 } from '../../utils/BrowserTest';
import { useTheme } from 'foundations-theming/utils';
import { useTableStyles } from './Table.styles';
import { TableContext } from './TableContext';
import { jsx as _jsx } from "react/jsx-runtime";
export const StyledContainer = styled.div.withConfig({
  displayName: "StickyHeaderTable__StyledContainer"
})(({
  theme,
  $cssStyles
}) => {
  return Object.assign({
    border: `${theme.borderWidth['100']} solid ${theme.color['border-transitional-core-subtle']}`
  }, $cssStyles);
});
export const StickyHeaderTable = props => {
  const {
      children,
      condensed = false,
      flush = true,
      hover = true,
      maxHeight,
      ScrollContainer = ScrollContainerComponent
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  const {
    domProps,
    tokenProps,
    callbackProps,
    restProps
  } = filterProps(rest);
  const cssStyles = useMapTokenPropsToCSS(tokenProps);
  const theme = useTheme();
  const {
    tableHeaderHeight
  } = useTableStyles();
  const tableVariantStyleOverrides = {
    borderBlockWidth: theme.borderWidth['0'],
    borderInlineWidth: theme.borderWidth['0'],
    '& thead': Object.assign({
      display: 'flex',
      position: isIE11() ? 'absolute' : 'sticky',
      top: theme.space['0'],
      backgroundColor: theme.color['specialty-table-header-default'],
      zIndex: 1
    }, !isIE11() && {
      borderBottom: `${theme.space['25']} solid ${theme.color['border-transitional-core-subtle']}`
    }),
    '& thead th': {
      borderTopWidth: theme.borderWidth['0']
    },
    '& tbody': Object.assign({
      display: 'table'
    }, isIE11() && {
      transform: `translateY(${tableHeaderHeight})`
    }),
    '& tbody tr:first-child td': Object.assign({}, !isIE11() && {
      borderTopWidth: theme.borderWidth['0']
    }),
    '& th:first-child, & td:first-child': {
      borderInlineStartWidth: theme.borderWidth['0']
    }
  };
  if (process.env.NODE_ENV !== 'production') {
    if (typeof maxHeight === 'string' && maxHeight.includes('%')) {
      devLogger.warn({
        message: 'StickyHeaderTable: `maxHeight` must be a fixed value, not a % value.',
        key: 'sticky-maxheight'
      });
    }
  }
  return /*#__PURE__*/_jsx(StyledContainer, Object.assign({}, domProps, callbackProps, restProps, {
    $cssStyles: cssStyles,
    children: /*#__PURE__*/_jsx(ScrollContainer, {
      maxHeight: maxHeight,
      scrollDirection: "both",
      children: /*#__PURE__*/_jsx(TableContext.Provider, {
        value: {
          bordered: true,
          condensed,
          _exteriorBorders: true,
          tableVariantStyleOverrides
        },
        children: /*#__PURE__*/_jsx(Table, {
          condensed: condensed,
          flush: flush,
          responsive: false,
          hover: hover,
          children: children
        })
      })
    })
  }));
};